import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '../Controls';
import { QuestionModal } from '../../../common';
import { useTranslation } from 'react-i18next';
import { MoreOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'antd';

const IconDropdown = ({ items }) => {
  const [confirmationAction, setConfirmationAction] = useState(undefined); // if there is action: {onClick, confirmation} modal is displayed and onClick is made after confirm
  const { t } = useTranslation();
  const navigate = useNavigate();

  const processPositiveAction = useCallback((currentItem) => {
    const { url } = currentItem;
    if (url) {
      // if contains url make redirect
      navigate(url);
    } else {
      currentItem.onClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderItem = (item) => {
    return (
      <div
        onClick={() =>
          item.confirmation
            ? setConfirmationAction(item)
            : processPositiveAction(item)
        }
      >
        <span style={{ marginTop: '-4px', marginRight: '10px' }}>
          {item.icon}
        </span>
        {item.disabled && item.showDisabledMessage
          ? item.title + ' (' + t('Pridávanie ukončené') + ')'
          : item.title}
      </div>
    );
  };

  const menuItems = useMemo(
    () =>
      items.map((item) => ({
        key: item.title,
        disabled: item.disabled,
        label: (
          <>
            {item.tooltip ? (
              <Tooltip title={item.tooltip}>{renderItem(item)}</Tooltip>
            ) : (
              renderItem(item)
            )}
          </>
        ),
      })),
    [items, processPositiveAction],
  );

  return (
    <>
      <Dropdown
        className="icon-dropdown-component"
        popupClassName="icon-dropdown-overlay"
        menu={{ items: menuItems, className: 'icon-dropdown-menu' }}
        placement="topLeft"
        trigger={['click']}
      >
        <span
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <IconButton
            className="dropdown-toggle-button"
            icon={<MoreOutlined />}
          />
        </span>
      </Dropdown>

      <QuestionModal
        chosenPositive={() => processPositiveAction(confirmationAction)}
        question={confirmationAction && confirmationAction.confirmation}
        visible={(confirmationAction && true) || false}
        yes={t('Áno')}
        toggle={() => setConfirmationAction(undefined)}
        headerTitle={t('Potvrdzovací dialóg')}
      />
    </>
  );
};

IconDropdown.propTypes = {
  items: PropTypes.array, //[{icon: string, title: string, onClick: fn, url: string}]
};

export default IconDropdown;
